import React from "react";
import { useHistory } from "react-router-dom";
import { useClient, useQuery, useMutation } from "jsonapi-react";
import { validatorModule } from "../../helpers/helpers";
import loginImage from "../../assets/images/login_img.png";
import logowhite from "../../assets/images/logo_w.png";
import logo from "../../assets/images/logo.png";
import { apiRoutes, VW_ROUTES } from "../../constants";
import { LuEye as EyeOpen } from "react-icons/lu";
import { LuEyeOff as EyeClose } from "react-icons/lu";
import PasswordValidationList from "../../components/PasswordValidationList/PasswordValidationList";
import { useToasts } from "react-toast-notifications";
import { logout } from "../../helpers/utils";

const passwordValidation = [
  {
    field: "new_password1",
    isPassword: true,
    fieldName: "New Password",
  },
];

const validationFormat = [
  ...passwordValidation,
  {
    field: "new_password2",
    isSameAs: {
      field: "new_password1",
      fieldName: "New Password",
    },
    isRequired: true,
    fieldName: "Confirm Password",
  },
];

export const VerifyUser = (props) => {
  const history = useHistory();
  const { addToast } = useToasts();
  const {
    match: {
      params: { email_key },
    },
  } = props;
  const initialState = {
    new_password1: "",
    new_password2: "",
    key: "",
  };
  const [formState, updateFormState] = React.useState(initialState);
  const [errorState, setErrorState] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [editStarted, setEditStarted] = React.useState(false);
  const [showPassWord, setShowPassword] = React.useState(false);

  const handleShowPassword = () => {
    setShowPassword((currState) => !currState);
  };

  const client = useClient();
  let mainError = "";
  if (sessionStorage.getItem("email_key") === email_key) {
    mainError = "Verification key has expired or already verified.";
  }
  const { error: verifyError, data: verifyData } = useQuery(
    sessionStorage.getItem("email_key") !== email_key && [
      "auth",
      "verify",
      "email",
      email_key,
    ]
  );
  if (verifyError && verifyError.detail) {
    mainError = verifyError.detail;
    sessionStorage.setItem("email_key", email_key);
  } else if (verifyData) {
    mainError = "";
    sessionStorage.setItem("email_key", email_key);
  }
  const [updatePassword] = useMutation(["auth", "password", "set"], {
    client,
  });
  const onInputChangeEvent = (e) => {
    updateFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const {
    data: systemInfo,
    error: errorInfo,
    isLoading: loading,
  } = useQuery(apiRoutes.systemInfo, {
    client,
  });

  const handlePasswordValidation = (isForm = false) => {
    const errorValidation = validatorModule(
      {
        new_password1: formState.new_password1,
        ...(isForm ? { new_password2: formState.new_password2 } : {}),
      },
      isForm ? validationFormat : passwordValidation
    );
    setErrorState(errorValidation);
    if (
      errorValidation?.new_password1?.find(
        (validateItem) => validateItem?.isError
      ) ||
      _.size(errorValidation?.new_password2)
    ) {
      return false;
    } else {
      return true;
    }
  };

  React.useEffect(() => {
    if (!editStarted && formState?.new_password1?.length) {
      setEditStarted(true);
    }
    handlePasswordValidation();
  }, [formState?.new_password1, editStarted]);

  const getPasswordErrorStatus = () =>
    errorState?.new_password1?.length &&
    errorState?.new_password1?.find((validateItem) => validateItem?.isError);

  const onResetPasswordSubmit = async (event) => {
    event.preventDefault();
    let isFormValid = handlePasswordValidation(true);
    if (isFormValid) {
      setIsLoading(true);
      const { error, data } = await updatePassword({
        ...formState,
        key: email_key,
      });
      setIsLoading(false);
      if (error) {
        addToast(error.detail, { appearance: "error" });
      } else if (data) {
        logout();
        history.push(VW_ROUTES.LOGIN);
      }
    }
  };
  return (
    <>
      <div className="login-cover">
        {mainError && <p className="verify-error">{mainError}</p>}
        <div className="left-section">
          <div className="content-portion">
            <div className="logo_w">
              <img src={logowhite} alt="v-watch" />
            </div>
            <h1>
              <span>Welcome to </span>v-watch Registration Portal
            </h1>
            <p>
              Vwatch a revolutionary solution for enterprises to become hybrid
              workplaces. We offer a comprehensive suite that will help you
              automate work with AI and optimise your space in alignment with
              the hybrid needs of your workforce.
            </p>
            <p>
              Smart Solutions for smarter places. Delight your workforce with
              features designed to make their workplace experiences more
              seamless.
            </p>
          </div>
          <div className="image-holder">
            <img src={loginImage} alt="v-watch" />
          </div>
        </div>

        <div className="right-section">
          <div className="content-portion">
            <div className="content-inner">
              <div className="logo">
                <img src={systemInfo?.site?.logo} alt="v-watch" />
              </div>
              <h2>Setup Password</h2>
              <p>Please enter details to reset your password.</p>

              <form onSubmit={onResetPasswordSubmit}>
                <label
                  className={`form-group has-float-label mb-4 ${
                    editStarted && getPasswordErrorStatus()
                      ? "hasValidationError"
                      : ""
                  }`}
                >
                  <div className="position-relative">
                    <input
                      onChange={(e) => onInputChangeEvent(e)}
                      name="new_password1"
                      type={showPassWord ? "text" : "password"}
                      className="form-control m-0"
                    />
                    <span
                      className="input-tail-icon p-0"
                      onClick={handleShowPassword}
                    >
                      {showPassWord ? <EyeOpen /> : <EyeClose />}
                    </span>
                  </div>
                  <span>Password</span>
                </label>
                <div className="mb-4 mx-2">
                  <PasswordValidationList
                    errorState={errorState?.new_password1}
                  />
                </div>
                <label
                  className={`form-group has-float-label mb-4 ${
                    errorState?.new_password2 ? "hasValidationError" : ""
                  }`}
                >
                  <input
                    onChange={(e) => onInputChangeEvent(e)}
                    name="new_password2"
                    type="password"
                    className="form-control m-0"
                    onPaste={(e) => e.preventDefault()}
                    onDrop={(e) => e.preventDefault()}
                    autoComplete="off"
                  />
                  <span>Confirm Password</span>
                  <p className="login-error-message">
                    {errorState && errorState?.new_password2
                      ? errorState.new_password2
                      : ""}
                  </p>
                </label>
                <div className="d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-secondary btn-lg btn-shadow"
                    type="submit"
                    disabled={isLoading || getPasswordErrorStatus()}
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="fixed-background login-background"></div>
            <main>
                <div className="container">
                    <div className="row h-100">
                        <div className="col-12 col-md-10 mx-auto my-auto">
                            <div className="card auth-card">
                                <div className="position-relative image-side login-inner-background">
                                    <p className="text-white h2">Welcome to TWRP Password Reset</p>
                                    <p className="white mb-0">Please enter details to reset your password.<br/>
                                    </p>
                                </div>
                                <div className="form-side"><a href="Dashboard.Default.html"><span className="logo-single"></span></a>
                                <p className="nonFieldError">{mainError}</p>
                                    <h6 className="mb-4">Setup Password</h6>
                                    <form onSubmit={onResetPasswordSubmit}>
                                        <label className="form-group has-float-label mb-4">
                                            <input onChange={(e) => onInputChangeEvent(e)} name="new_password1" type="password" className="form-control" />
                                            <span>Password</span>
                                            <p className="login-error-message">{errorMsgs && errorMsgs.field === 'newPassword1' ? errorMsgs.errorMsg : ''}</p>
                                        </label>
                                        <label className="form-group has-float-label mb-4">
                                            <input onChange={(e) => onInputChangeEvent(e)} name="new_password2" type="password" className="form-control" />
                                            <span>Confirm Password</span>
                                            <p className="login-error-message">{errorMsgs && errorMsgs.field === 'newPassword2' ? errorMsgs.errorMsg : ''}</p>
                                        </label>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <button className="btn btn-primary btn-lg btn-shadow" type="submit">SUBMIT</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main> */}
    </>
  );
};

export default VerifyUser;
